import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '@/js/libs/ui/src/theme/Media';
import { Loader } from '../../../../Elements/Loader';
import { PageInfoWrapper } from './styled';
export const PageInfo = memo(function PageInfo({ from, to, total, isLoading, dataTestId }) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    return (_jsxs(PageInfoWrapper, { "data-testid": dataTestId, children: [isLoading && _jsx(Loader, { cover: true }), !isMobile && (total ? `${from} - ${to} / ${total}` : `0 / 0`), isMobile && (total ? `${from}-${to}/${total}` : `0/0`)] }));
});
